import React from "react";
import { useTranslation } from "react-i18next";

import googleIcon    from "../../images/google-play.svg";
import appleIcon     from "../../images/apple.svg";
import telegramIcon  from "../../../assets/icons/telegram.svg";
import instagramIcon from "../../../assets/icons/instagram.svg";
import tiktokIcon    from "../../../assets/icons/tiktok.svg";

const SOCIALS = [
    { icon: telegramIcon,  alt: "Telegram",  href: null },
    { icon: instagramIcon, alt: "Instagram", href: "https://www.instagram.com/agroland.kz?igsh=M2xieDF1bDdwYWFl&utm_source=qr" },
    { icon: tiktokIcon,    alt: "TikTok",    href: "https://www.tiktok.com/@agroland.kz?_t=ZM-8wXe6Zcgigi&_r=1" },
];

const APP_LINKS = [
    { icon: googleIcon, store: "Google Play", href: "https://play.google.com/store/apps/details?id=com.agroland.app&pcampaignid=web_share" },
    { icon: appleIcon,  store: "App Store",   href: "https://apps.apple.com/us/app/agroland/id6743326709" },
];

function NavigationBottom() {
    const { t } = useTranslation();

    return (
        <div className="shrink-0 border-t border-[#EDEDED] px-5 py-4 flex flex-col gap-3">

            {/* Phone + socials row */}
            <div className="flex items-center justify-between">
                <p className="m-0 text-[18px] font-bold text-[#222222] leading-none">
                    +7 (707) 538 88 35
                </p>
                <ul className="list-none p-0 m-0 flex gap-1.5">
                    {SOCIALS.map(({ icon, alt, href }) => {
                        const btn = (
                            <span className="w-8 h-8 rounded-full bg-[#F9F9F9] hover:bg-[#e8f5ea]
                                flex items-center justify-center cursor-pointer
                                transition-colors duration-150">
                                <img src={icon} alt={alt} width={16} height={16} />
                            </span>
                        );
                        return (
                            <li key={alt}>
                                {href
                                    ? <a href={href} target="_blank" rel="noreferrer">{btn}</a>
                                    : btn}
                            </li>
                        );
                    })}
                </ul>
            </div>

            {/* Address */}
            <p className="m-0 text-[11px] text-[#939393] leading-relaxed">
                Орбита-4, д.11, оф.357, Алматы
            </p>

            {/* App download — side by side */}
            <div className="flex gap-2">
                {APP_LINKS.map(({ icon, store, href }) => (
                    <a
                        key={store}
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className="flex-1 flex items-center gap-2 px-3 py-2 bg-[#F9F9F9]
                            rounded-xl no-underline border border-[#EDEDED]
                            hover:border-[#147F26] hover:bg-[#e8f5ea]
                            transition-colors duration-150"
                    >
                        <img src={icon} alt={store} width={22} height={22} className="shrink-0" />
                        <div>
                            <p className="m-0 text-[9px] text-[#939393] leading-none">{t("download")}</p>
                            <p className="m-0 text-[12px] font-semibold text-[#222222] leading-tight">{store}</p>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
}

export default NavigationBottom;
